import React from "react";
import {
    Navbar,
    IconButton, Collapse
} from "@material-tailwind/react";
import Logo from "../general/Logo";
import {useNavigate} from "react-router";
import ProfileMenu from "./ProfileMenu";
import LeftSideBar from "./LeftSideBar";
import {MoreVert} from "@mui/icons-material";
import {MenusHeader} from "./MenusHeader";

interface Props {
    test?: boolean;
}

export function Header({test}: Props) {
    const [isNavOpen, setIsNavOpen] = React.useState(false);
    const history = useNavigate();

    React.useEffect(() => {
        window.addEventListener(
            "resize",
            () => window.innerWidth >= 960 && setIsNavOpen(false),
        );
    }, []);
    const toggleIsNavOpen = () => setIsNavOpen((cur) => !cur);

    return (
        <Navbar placeholder='navbar'
                className="fixed bg-header border-0 min-w-full grid items-center rounded-none sm:h-[70px] z-30 p-0">
            <div className="bg-header sm:ml-0 flex flex-col sm:flex-row items-center text-white px-2 py-1 gap-2">
                <div className={"border-gray-100 items-center flex p-1 sm:p-0 cursor-pointer"}>
                    {!test && <Logo width={'40px'} onClick={() => {
                        history('')
                    }}/>
                    }
                </div>
                <div className={'ml-auto w-full flex flex-row p-1 sm:p-0'}>
                    <IconButton placeholder="icon-button"
                                size="sm"
                                variant="text"
                                onClick={toggleIsNavOpen}
                                className=" mr-2 sm:hidden"
                    >
                        <MoreVert className="h-6 w-6 text-white"/>
                    </IconButton>
                    <ProfileMenu/>
                </div>
            </div>
            {!isNavOpen && <MenusHeader visible={false}/>}
            <Collapse open={isNavOpen} className="bg-white">
                <div className={'h-screen'}>
                    {<MenusHeader visible={true} {...{toggleIsNavOpen}}/>}
                    {isNavOpen && <LeftSideBar {...{toggleIsNavOpen}}/>}
                </div>
            </Collapse>
        </Navbar>
    );
}

export default Header
